import logoImg from "./assets/logo/logo.png";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Home from "./pages/Home";
import Services from "./pages/Services";

// ai development services
import { ReactComponent as Icon1 } from "./assets/svgs/Machine Learning.svg";
import { ReactComponent as Icon2 } from "./assets/svgs/NLP.svg";
import { ReactComponent as Icon3 } from "./assets/svgs/AI System Integration.svg";
import { ReactComponent as Icon4 } from "./assets/svgs/Computer Vision.svg";
import { ReactComponent as Icon5 } from "./assets/svgs/Predictive Analytics.svg";

// ai development services
import { ReactComponent as Icon6 } from "./assets/svgs/Chatbots.svg";
import { ReactComponent as Icon7 } from "./assets/svgs/Custom Chatbot Development.svg";
import { ReactComponent as Icon8 } from "./assets/svgs/Business Process Automation with Conversational AI.svg";
import { ReactComponent as Icon9 } from "./assets/svgs/Multilingual Chatbots.svg";
import { ReactComponent as Icon10 } from "./assets/svgs/Platform Integration.svg";

export { logoImg };

export const companyDetails = {
  phone: "+919620715510",
  phone2: "+919901933775",
  address:
    "208, Shri Sannidhi Apartment, 2nd Cross, Chikkappanna Layout, Hennur, Bengaluru - 560043",
  email: "ceo@authaisolutions.com",
  linkedin: "https://www.linkedin.com/in/raghavendra-gs-683b73329/",
  instagram:
    "https://www.instagram.com/authaisolutions2024/profilecard/?igsh=a2U1cW9oaWlzNXFl",
  twitter: "https://x.com/authaisolutions",
};

export const routes = [
  {
    path: "/",
    name: "Home",
    element: <Home />,
  },
  {
    path: "/about-us",
    name: "About Us",
    element: <AboutUs />,
  },
  {
    path: "/services",
    name: "Services",
    element: <Services />,
  },
  {
    path: "/contact-us",
    name: "Contact Us",
    element: <ContactUs />,
  },
];

// web development services
export const webDevelopmentServices = [
  {
    id: 1,
    title: "E-commerence Websites",
    icon: require("./assets/images/icons/online-shopping.png"),
    description:
      "Empowering your online business with tailored ecommerce solutions. Our platforms boost customer engagement, streamline operations, and drive revenue growth. ",
  },
  {
    id: 2,
    title: "Social Media Websites",
    icon: require("./assets/images/icons/socialmedia.png"),
    description:
      "Get custom social media websites that captivate and engage your audience, driving growth and brand loyalty effortlessly",
  },
  {
    id: 3,
    title: "Landing Websites",
    icon: require("./assets/images/icons/landing-page.png"),
    description:
      " Creating high-converting landing pages that capture attention and drive action. Tailored designs that showcase your brand’s message and maximize conversions.",
  },
  {
    id: 4,
    title: "Custom Websites",
    icon: require("./assets/images/icons/software-development.png"),
    description:
      "Delivering tailor-made websites designed to meet your unique business needs. Our solutions blend creativity and functionality for an exceptional online experience.",
  },
];

// app development services
export const appDevelopmentServices = [
  {
    id: 1,
    title: "iOS App Development",
    icon: require("./assets/images/icons/ios-development.png"),
    description:
      "Our skilled developers work with both Swift and Objective-C to build robust and efficient apps. We optimize your app for performance, speed, and responsiveness.",
  },
  {
    id: 2,
    title: "Android App Development",
    icon: require("./assets/images/icons/android-development.png"),
    description:
      "We design and develop tailor-made Android apps that align with your vision and business goals.Proficient in both Java and Kotlin, we build robust and efficient apps.",
  },
  {
    id: 3,
    title: "Flutter App Development",
    icon: require("./assets/images/icons/flutter-development.png"),
    description:
      "Flutter allows you to build apps for both iOS and Android using a single codebase. While Flutter's default web app architecture presents challenges, we can overcome them with smart strategies. ",
  },
  {
    id: 4,
    title: "Hybrid App Development",
    icon: require("./assets/images/icons/hybrid-app-development.png"),
    description:
      "We build feature-rich hybrid apps tailored to your business needs. We create mobile-friendly apps that work seamlessly across iOS and Android devices.",
  },
];

// ai development services
export const aiDevelopmentServices = [
  {
    id: 1,
    title: "Machine Learning Solutions",
    icon: Icon1,
    description:
      "Empower your business with custom machine learning algorithms that predict outcomes, identify trends, and automate complex tasks. Drive innovation through data-driven decisions and measurable value.",
  },
  {
    id: 2,
    title: "Natural Language Processing (NLP)",
    icon: Icon2,
    description:
      "Develop NLP-powered applications that understand and interpret human language. From sentiment analysis to intelligent chatbots, our solutions help you engage customers effectively and extract insights from text data.",
  },
  {
    id: 3,
    title: "AI System Integration and Optimization",
    icon: Icon3,
    description:
      "Seamlessly integrate AI into your existing infrastructure. We implement solutions that fit your environment, unlock efficiencies, and continuously optimize as your business grows.",
  },
  {
    id: 4,
    title: "Computer Vision",
    icon: Icon4,
    description:
      "Enable systems to analyze and interpret images and video content. From facial recognition to object detection, we create tailored solutions that extract valuable insights from visual data.",
  },
  {
    id: 5,
    title: "Predictive Analytics",
    icon: Icon5,
    description:
      "Forecast future trends, optimize strategies, and anticipate challenges with our predictive analytics tools. Make better business decisions by staying one step ahead of market shifts and customer demand.",
  },
];

// chatbot development services
export const chatbotDevelopmentServices = [
  {
    id: 1,
    title: "AI-Powered Chatbots",
    icon: Icon6,
    description:
      "Our AI-powered chatbots provide efficient, real-time responses to customer inquiries, helping businesses offer a more personalized and responsive service. By incorporating machine learning and natural language processing, we build chatbots that can handle complex interactions, learn from past conversations, and continually improve their performance to meet customer needs.",
  },
  {
    id: 2,
    title: "Custom Chatbot Development",
    icon: Icon7,
    description:
      "We understand that each business has its own set of needs, which is why we offer fully customized chatbot solutions. From designing user-friendly conversational flows to integrating APIs for third-party services, we ensure that your chatbot is tailored to your business goals and provides a seamless user experience.",
  },
  {
    id: 3,
    title: "Business Process Automation with Conversational AI",
    icon: Icon8,
    description:
      "AI-powered chatbots can do more than just engage with customers—they can automate key business processes. Our conversational AI solutions streamline tasks like appointment scheduling, order processing, and data collection, allowing your team to focus on more strategic activities while increasing overall operational efficiency.",
  },
  {
    id: 4,
    title: "Multilingual Chatbots",
    icon: Icon9,
    description:
      "As businesses expand their reach, supporting customers in multiple languages becomes essential. We design multilingual chatbot solutions that ensure your customers receive consistent, personalized support no matter where they are located or what language they speak.",
  },
  {
    id: 5,
    title: "Platform Integration",
    icon: Icon10,
    description:
      "To ensure a seamless customer experience, we integrate chatbots across the platforms you use most, whether it's your website, mobile app, or social media channels. Our chatbot solutions work across messaging platforms like Facebook Messenger, WhatsApp, and more, providing consistent support on the platforms your customers are already using.",
  },
];

// portfolio
// export const portfolio = [
//   {
//     id: 1,
//     title: "Figo Tech",
//     img: require("./assets/images/portfolio/1.jpeg"),
//     imgFit: "object-cover",
//   },
//   {
//     id: 2,
//     title: "News Feed",
//     img: require("./assets/images/portfolio/2.jpeg"),
//     imgFit: "object-cover",
//   },
//   {
//     id: 3,
//     title: "Food Application",
//     img: require("./assets/images/portfolio/3.png"),
//     imgFit: "object-contain",
//   },
//   {
//     id: 4,
//     title: "Crio Load App",
//     img: require("./assets/images/portfolio/4.jpg"),
//     imgFit: "object-cover",
//   },
// ];

// testimonials
export const testimonials = [
  {
    id: 1,
    name: "John Doe",
    position: "CEO of Innovative Tech Corp",
    img: require("./assets/images/testimonial1.png"),
    desc: "“Partnering with AUTH AI SOLUTIONS has been nothing short of a revelation for our organization. Their unwavering commitment to ethical AI has not only streamlined our operations but has also resonated deeply with our core values”",
  },
  {
    id: 2,
    name: "Sarah Jardin",
    position: "Director of Operations at Green Future Ltd",
    img: require("./assets/images/testimonial2.png"),
    desc: "“The exceptional team at AUTH AI SOLUTIONS took the time to thoroughly understand our unique challenges and crafted bespoke solutions that far exceeded our expectations.”",
  },
  {
    id: 3,
    name: "Velicia Jamez",
    position: "CTO of Health Innovations Group",
    img: require("./assets/images/testimonial3.png"),
    desc: "“AUTH AI SOLUTIONS stands at the forefront of ethical artificial intelligence. Their invaluable insights and expertise have been instrumental as we navigate the intricate landscape of implementing AI technologies within our business.”",
  },
];

// all services
export const allServices = [
  {
    id: 1,
    title: "Web Development",
    description:
      "Our full-stack development services provide end-to-end solutions, combining front-end and back-end expertise for a future-proof digital presence.",
    icon: require("./assets/images/icons/webdev.png"),
    detailContent:
      "In today's interconnected world, website applications have become an integral part of our daily lives. From e-commerce platforms to social media networks, from educational resources to government services, these digital tools have revolutionized the way we interact, communicate, and conduct business. The development of website applications is a complex process that involves a blend of creativity, technical expertise, and a deep understanding of user needs. \n\n At the core of website application development lies the interplay of front-end and back-end development. The front-end, or client-side, is what the user sees and interacts with. It encompasses the design, layout, and functionality of the website's interface. Popular front-end technologies include HTML, CSS, and JavaScript frameworks like React, Angular, and Vue.js. These tools enable developers to create visually appealing and intuitive user experiences.",
  },
  {
    id: 2,
    title: "Mobile App Development",
    description:
      "Achieve Mobile Supremacy through Custom App Development Solutions that Combine User- Centric Design, Seamless Functionality, and Sustainable Business Growth.",
    icon: require("./assets/images/icons/appdev.png"),
    detailContent:
      "One of the key differences between mobile and web app development is the platform-specific nature of mobile apps. While web apps can be accessed on any device with a web browser, mobile apps are designed for specific platforms, such as iOS and Android. This necessitates developing separate versions for each platform, often using different programming languages and development environments.\n\nPerformance is another critical factor in mobile app development. With limited processing power and battery life, mobile devices demand optimized apps that run smoothly and efficiently. Developers must carefully consider factors such as memory usage, network connectivity, and power consumption to ensure a positive user experience.",
  },
  {
    id: 3,
    title: "Cloud Migration Services",
    description:
      "Seamlessly transition your business to the cloud with expert migration strategies that minimize risk and maximize performance.",
    icon: require("./assets/images/icons/cloud.png"),
    detailContent:
      "One of the primary drivers of cloud migration is the need for scalability. Traditional on-premises infrastructure can be inflexible, making it difficult to accommodate rapid growth or fluctuating workloads. Cloud platforms, on the other hand, offer virtually unlimited scalability, allowing businesses to easily adjust their resources to meet changing demands. This flexibility can significantly reduce costs and improve operational efficiency.\n\nCost-effectiveness is another compelling reason for organizations to consider cloud migration. Cloud providers often offer pay-as-you-go pricing models, which can result in significant cost savings compared to the upfront investments required for on-premises infrastructure. Additionally, cloud platforms can help reduce IT operational costs by automating routine tasks and eliminating the need for on-premises data centers.",
  },
  {
    id: 4,
    title: "AI Development",
    description:
      "Unlock Next-Gen Customer Experience with Expertly Crafted Conversational AI ",
    icon: require("./assets/images/icons/ai.png"),
    detailContent:
      "At the heart of AI development is the creation of algorithms and models that enable machines to learn from data and improve their performance over time. Machine learning, a subset of AI, involves training algorithms on large datasets to recognize patterns, make predictions, and automate tasks. Deep learning, a more advanced form of machine learning, utilizes artificial neural networks to process complex data and learn from it.\n\nAI development has a wide range of applications across various domains. In healthcare, AI is being used to diagnose diseases, develop new treatments, and personalize patient care. In finance, AI-powered systems are used for fraud detection, risk assessment, and algorithmic trading. In manufacturing, AI is driving automation, improving efficiency, and enhancing product quality.",
  },
  {
    id: 5,
    title: "Data Science Services",
    description:
      "Accelerate Business Growth and Unlock New Revenue Streams with Our Expert Data Science Solutions.",
    icon: require("./assets/images/icons/datascience.png"),
    detailContent:
      "At the core of data science services lies the ability to collect, clean, and prepare data for analysis. Data scientists employ a variety of techniques to ensure data quality and reliability, including data cleansing, normalization, and feature engineering. Once the data is prepared, it can be subjected to statistical analysis, machine learning algorithms, and other data mining techniques to uncover meaningful patterns and trends.\n\nOne of the key benefits of data science services is the ability to make data-driven decisions. By analyzing vast amounts of data, businesses can gain valuable insights into customer behavior, market trends, and operational efficiency. Data science services also play a crucial role in driving innovation. By leveraging advanced analytics techniques, businesses can develop new products and services, identify emerging opportunities, and stay ahead of the competition. Additionally, data science can be used to create predictive models that can forecast future trends and anticipate risks.",
  },
  {
    id: 6,
    title: "IT Consulting & Strategy",
    description:
      "Connect IT and Business for Unparalleled Success with Our Expert Consulting, Aligning IT Infrastructure with Business Goals.",
    icon: require("./assets/images/icons/itconsulting.png"),
    detailContent:
      "One of the primary roles of IT consulting firms is to help businesses align their IT strategies with their overall business objectives. By conducting thorough assessments and analyses, consultants can identify areas for improvement and recommend solutions that optimize efficiency, reduce costs, and enhance competitiveness. This may involve implementing new technologies, upgrading existing systems, or restructuring IT operations.\n\nIT consulting firms also play a vital role in addressing the security challenges faced by businesses today. In an increasingly interconnected world, protecting sensitive data from cyber threats is crucial. Consultants can help organizations assess their security vulnerabilities, implement robust security measures, and develop incident response plans to minimize the impact of potential breaches.",
  },
  {
    id: 7,
    title: "Chatbot Development",
    description:
      "Chatbots to Re-define Customer Interaction, Drive Revenue, and Future-Proof Your Business.",
    icon: require("./assets/images/icons/chatbot.png"),
    detailContent:
      "Chatbots are powered by natural language processing (NLP), a field of artificial intelligence that enables machines to understand and interpret human language. NLP techniques allow chatbots to process and analyze text, extract meaning, and generate appropriate responses. This capability has led to the development of chatbots that can engage in meaningful conversations, answer questions, and even provide personalized recommendations.\n\nOne of the primary benefits of chatbots is their ability to improve customer service. By automating routine tasks and providing immediate responses to customer inquiries, chatbots can reduce wait times, enhance customer satisfaction, and free up human agents to handle more complex issues. Additionally, chatbots can be used to collect customer feedback and insights, helping businesses to identify areas for improvement and tailor their offerings to meet customer needs.",
  },
  {
    id: 8,
    title: "Data Analytics & Business Intelligence",
    description:
      "Our cutting-edge analytics and Business Intelligence capabilities distil complex data in to clear, actionable insights.",
    icon: require("./assets/images/icons/dataanalytics.png"),
    detailContent:
      "Data analytics involves the process of examining data to uncover patterns, trends, and insights. It encompasses a wide range of techniques, including statistical analysis, machine learning, and data mining. By applying these methods to large datasets, organizations can extract valuable information that can be used to inform decision-making.\n\nBusiness intelligence, on the other hand, focuses on providing actionable insights to support strategic decision-making. BI tools and platforms enable organizations to collect, store, and analyze data from various sources, transforming raw data into meaningful information that can be easily understood and visualized.",
  },
  {
    id: 9,
    title: "Natural Language Processing (NLP)",
    description:
      "Our advanced NLP capabilities empower applications to decipher, analyze, and respond to human language.",
    icon: require("./assets/images/icons/nlp.png"),
    detailContent:
      "NLP has a wide range of applications across various domains. In customer service, chatbots and virtual assistants powered by NLP can provide immediate responses to customer inquiries and automate routine tasks. In healthcare, NLP can be used to analyze medical records, extract information from clinical notes, and assist in drug discovery. In the legal field, NLP can be used to automate document review, extract key information from legal contracts, and provide legal research assistance.\n\nAs NLP technology continues to advance, we can expect to see even more innovative applications emerging. For example, NLP-powered systems could be used to create intelligent personal assistants that can understand our needs and preferences, or to develop more accurate and natural-sounding language translation tools.However, the development of NLP is not without its challenges. Issues such as bias, privacy, and ethical considerations must be carefully addressed.",
  },
];

// portfolio images (web development)
export const webPortfolio = [
  {
    id: 1,
    img: require("./assets/images/web_projects/1.webp"),
    title: "FE-Finance",
  },
  {
    id: 2,
    img: require("./assets/images/web_projects/2.webp"),
    title: "Ocxee",
  },
  {
    id: 3,
    img: require("./assets/images/web_projects/3.webp"),
    title: "Leaderbridge",
  },
  {
    id: 4,
    img: require("./assets/images/web_projects/4.webp"),
    title: "Gigzio",
  },
  {
    id: 5,
    img: require("./assets/images/web_projects/5.webp"),
    title: "FE Group",
  },
  {
    id: 6,
    img: require("./assets/images/web_projects/6.webp"),
    title: "V Talkz",
  },
];

// portfolio images (app development)
export const appPortfolio = [
  {
    id: 1,
    img: require("./assets/images/app_projects/1.webp"),
    title: "PartEx",
  },
  {
    id: 2,
    img: require("./assets/images/app_projects/2.webp"),
    title: "Find A Driver",
  },
  {
    id: 3,
    img: require("./assets/images/app_projects/3.webp"),
    title: "Artisan Express",
  },
  {
    id: 4,
    img: require("./assets/images/app_projects/4.webp"),
    title: "House of Deliverance",
  },
];
